import React, { useEffect } from 'react';
import { META_DESCRIPTION, META_PIXEL_ID, PAGE_TITLE } from './data/content';
import { bonusCovers, heroMockupUrl, offerMockupUrl, pageImages } from './data/images';
import { initMetaPixel } from './utils/metaPixel';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { StatsBand } from './components/StatsBand';
import { BeforeAfter } from './components/BeforeAfter';
import { VolumesSection } from './components/VolumesSection';
import { LookInsideSection } from './components/LookInsideSection';
import { MeetingSelector } from './components/MeetingSelector';
import { SolutionSection } from './components/SolutionSection';
import { ValuesBand } from './components/ValuesBand';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
const pixelNoscript = META_PIXEL_ID ? `<img height="1" width="1" style="display:none" alt="" src="https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1" />` : '';

// v2 (23/10): 52 complete classes in 5 volumes. The 5 volumes go right after the before/after (the new promise, seen
// early); the 52-week plan and the list of 10 classes of v1 are replaced by VolumesSection; the values band and the
// bonuses are shorter on mobile, so the offer is about 5 screens closer.
export function App() {
  useEffect(() => {
    document.title = PAGE_TITLE;
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = META_DESCRIPTION;
    initMetaPixel();
  }, []);
  return <div id="top" className="min-h-screen w-full overflow-x-hidden bg-white font-sans text-ink antialiased" data-id="element-0" data-mp="35oxgs1yt6tn">
      {pixelNoscript && <noscript dangerouslySetInnerHTML={{
      __html: pixelNoscript
    }} data-id="element-1" data-mp="3uc9j1w993mja" />}
      <TopBar data-id="element-2" data-mp="d4xpvgh6mddw" />
      <main data-id="element-3" data-mp="d3cvbquvaug1">
        <Hero heroMockupUrl={heroMockupUrl} data-id="element-4" data-mp="d45vg8zbmlp7" />
        <StatsBand data-id="element-5" data-mp="85ujnspgu14c" />
        <BeforeAfter data-id="element-6" data-mp="85bc95xfyv4k" />
        <VolumesSection data-id="element-7" data-mp="864afiic4cb3" />
        <LookInsideSection pageImages={pageImages} data-id="element-8" data-mp="83i6dsunkexm" />
        <MeetingSelector data-id="element-9" data-mp="3gmfwxlp4rgd9" />
        <SolutionSection data-id="element-10" data-mp="3glnze5bz38kc" />
        <ValuesBand data-id="element-11" data-mp="3gj1vqgs7dd7e" />
        <BonusesSection bonusCovers={bonusCovers} data-id="element-12" data-mp="3bmtjbb5e3y3x" />
        <OfferSection offerMockupUrl={offerMockupUrl} data-id="element-13" data-mp="3bo4kr4bd4trv" />
        <GuaranteeSection data-id="element-14" data-mp="3qbfx38fdcht1" />
        <FaqSection data-id="element-15" data-mp="3qcr0360zplj3" />
        <FinalCta data-id="element-16" data-mp="3qdai0mqn49x4" />
      </main>
      <Footer data-id="element-17" data-mp="3lkr57rzs1itd" />
      <StickyCta data-id="element-18" data-mp="3lk7lq6uhamd8" />
    </div>;
}